export class SyncStoreAnimalWeight {
  constructor(
    readonly animals: number,
    readonly weight: number) {}
}
